export function formatCurrencyForSubmit(value?: string) {
  return value ? value.replace(/\.$/, '') : value;
}

export function stripZeroCents(amount: string) {
  return amount.replace(/\.0+$/, '');
}

const USD_FORMAT = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });

// Formats a numeric string as USD (e.g. an account balance). Returns `undefined` for a null/absent
// amount and falls back to the raw string when it isn't a finite number.
export function formatUsd(amount: string | null | undefined): string | undefined {
  if (amount === null || amount === undefined) return undefined;
  const numeric = Number(amount);
  return Number.isFinite(numeric) ? USD_FORMAT.format(numeric) : amount;
}
